module.exports = __webpack_public_path__ + "images/372989265f4e853fd53567fd8a335135-illu_dir_image2.svg";